export const LIST_COURSES_REQ = "LIST_COURSES_REQ";
export const LIST_COURSES_SUCCESS = "LIST_COURSES_SUCCESS";
export const LIST_COURSES_FAILED = "LIST_COURSES_FAILED";

export const LIST_COURSES_SINGLE_REQ = "LIST_COURSES_SINGLE_REQ";
export const LIST_COURSES_SINGLE_SUCCESS = "LIST_COURSES_SINGLE_SUCCESS";
export const LIST_COURSES_SINGLE_FAILED = "LIST_COURSES_SINGLE_FAILED";
export const LIST_COURSES_SINGLE_RESET = "LIST_COURSES_SINGLE_RESET";

export const CREATE_COURSE_REQ = "CREATE_COURSE_REQ";
export const CREATE_COURSE_SUCCESS = "CREATE_COURSE_SUCCESS";
export const CREATE_COURSE_FAILED = "CREATE_COURSE_FAILED";
export const CREATE_COURSE_RESET = "CREATE_COURSE_RESET";

export const TOTAL_COURSES_COUNT_REQ = "TOTAL_COURSES_COUNT_REQ";
export const TOTAL_COURSES_COUNT_SUCCESS = "TOTAL_COURSES_COUNT_SUCCESS";
export const TOTAL_COURSES_COUNT_FAILED = "TOTAL_COURSES_COUNT_FAILED";

export const UPDATE_COURSE_REQ = "UPDATE_COURSE_REQ";
export const UPDATE_COURSE_SUCCESS = "UPDATE_COURSE_SUCCESS";
export const UPDATE_COURSE_FAILED = "UPDATE_COURSE_FAILED";
export const UPDATE_COURSE_RESET = "UPDATE_COURSE_RESET";

export const DELETE_COURSE_REQ = "DELETE_COURSE_REQ";
export const DELETE_COURSE_SUCCESS = "DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAILED = "DELETE_COURSE_FAILED";
export const DELETE_COURSE_RESET = "DELETE_COURSE_RESET";

export const CAMPUS_ADD_BY_COURSES_REQ = "CAMPUS_ADD_BY_COURSES_REQ";
export const CAMPUS_ADD_BY_COURSES_SUCCESS = "CAMPUS_ADD_BY_COURSES_SUCCESS";
export const CAMPUS_ADD_BY_COURSES_FAILED = "CAMPUS_ADD_BY_COURSES_FAILED";
export const CAMPUS_ADD_BY_COURSES_RESET = "CAMPUS_ADD_BY_COURSES_RESET";

export const CAMPUS_DELETE_BY_COURSES_REQ = "CAMPUS_DELETE_BY_COURSES_REQ";
export const CAMPUS_DELETE_BY_COURSES_SUCCESS =
  "CAMPUS_DELETE_BY_COURSES_SUCCESS";
export const CAMPUS_DELETE_BY_COURSES_FAILED =
  "CAMPUS_DELETE_BY_COURSES_FAILED";
